import { z } from 'zod';
import type {
    CloverTerminalSaleRequestBody,
    CloverTerminalSaleRequestDetails,
    CloverTerminalSaleRequestHeaders,
} from '../../../types/ipg/clover/clover-terminal-sale.types';

export const CloverTerminalSaleAmountSchema: z.ZodNumber = z.number().int().min(1).max(999999999);

export const CloverTerminalSaleRequestHeadersSchema: z.ZodObject<{
    deviceId: z.ZodString;
    idempotencyKey: z.ZodString;
    posId: z.ZodString;
    userAgent: z.ZodString;
    timeoutSeconds: z.ZodOptional<z.ZodNumber>;
}> = z.object({
    deviceId: z.string().min(1),
    idempotencyKey: z.string().min(1),
    posId: z.string().min(1),
    userAgent: z.string().min(1),
    timeoutSeconds: z.number().int().min(0).max(300).optional(),
}) satisfies z.ZodType<CloverTerminalSaleRequestHeaders>;

export const CloverTerminalSaleRequestBodySchema: z.ZodObject<{
    amount: z.ZodNumber;
    externalPaymentId: z.ZodString;
    final: z.ZodLiteral<true>;
    capture: z.ZodOptional<z.ZodLiteral<true>>;
    externalReferenceId: z.ZodOptional<z.ZodString>;
    tipAmount: z.ZodOptional<z.ZodNumber>;
}> = z.object({
    amount: CloverTerminalSaleAmountSchema,
    externalPaymentId: z.string().min(1),
    final: z.literal(true),
    capture: z.literal(true).optional(),
    externalReferenceId: z.string().min(1).max(12).optional(),
    tipAmount: z.number().int().min(0).max(999999999).optional(),
}) satisfies z.ZodType<CloverTerminalSaleRequestBody>;

export const CloverTerminalSaleRequestDetailsSchema: z.ZodObject<{
    method: z.ZodLiteral<'POST'>;
    path: z.ZodLiteral<'/v1/payments'>;
    headers: typeof CloverTerminalSaleRequestHeadersSchema;
    body: typeof CloverTerminalSaleRequestBodySchema;
}> = z.object({
    method: z.literal('POST'),
    path: z.literal('/v1/payments'),
    headers: CloverTerminalSaleRequestHeadersSchema,
    body: CloverTerminalSaleRequestBodySchema,
}) satisfies z.ZodType<CloverTerminalSaleRequestDetails>;
